export default __webpack_public_path__ + "static/media/Snd_g4.142d83ee.mp3";